export const reports = {
    actions: ['Корректирующие действия', 'Actions'],
    basicInfo: ['Общая информация', 'Basic info'],
    cancelDeletion: ['Отменить удаление', 'Cancel deletion'],
    dateClosed: ['Дата закрытия', 'Date closed'],
    dateReceived: ['Получено', 'Date received'],
    daysToProcess: ['Срок исправления', 'Days to process'],
    deleteReport: ['Удалить доклад', 'Delete report'],
    enterBasicInfo: ['Введите общую информацию', 'Enter basic info'],
    feedbackInfo: ['Обработка', 'Feedback info'],
    flightInfo: ['Рейс', 'Flight info'],
    flightNameDateTime: ['{{flightName}} за {{datetime}}', '{{flightName}} at {{datetime}}'],
    limitDownloadReports: ['Ограничение на загрузку составляет 30 докладов.', 'The limit for downloading is 30 reports.'],
    maxAttachImages: ['Максимальное количество вложенных изображений: {{maxCount}}', 'Maximum attached images count is {{maxCount}}'],
    periodNotExceed: ['Период не должен превышать 31 день.', 'The period must not exceed 31 days.'],
    reason: ['Причина', 'Reason'],
    report: ['Доклад №', 'Report №'],
    reportDetails: ['Детали доклада', 'Report details'],
    reportGroupTypes: ['Вид доклада', 'Report group types'],
    reportInfo: ['Информация по докладу', 'Report info'],
    reportStatus: ['Статус доклада', 'Report status'],
    reportTypeGroup: ['Доклад', 'Report type(group)'],
    reportTypes: ['Доклад', 'Report types'],
    responsiblePersonDepartment: ['Ответственный сотрудник или подразделение', 'Responsible person or department'],
    status: ['Статус', 'Status'],
    statusDate: ['Дата проставления статуса', 'Status date'],
};
